<template>
    <page>  
      <template slot='content'>
        <os-empilhadeiras-component></os-empilhadeiras-component>
        <reloadPage></reloadPage>
      </template>
    </page>
  </template>
  
<script>
  import Page from '@/components/Page'
  import OsEmpilhadeirasComponent from '../components/Armazem/OsEmpilhadeirasComponent.vue'
  // import IndicadoresResumo from '@/components/IndicadoresResumo'
  import reloadPage from '../common/reloadPage.vue'
  
  export default {
    components: {
      Page,
      OsEmpilhadeirasComponent,
      reloadPage
    },
    beforeDestroy() {
      clearTimeout(this.timer)
    },
    created () {
      
    },
  
    data() {
      return {
        isSidebarOpen: false,
        breadcrumbItems: [
          {
            text: 'Ordens para atendimento',
            active: true
          }
        ],
        timer: ''
      }
    },
    methods: {

    }
  }
  </script>
  